@if (form$ | async; as form) {
  <div class="call-codes-details">
    <nimbus-form-wrapper [formGroup]="form">
      @if (task?.conversationCodes?.primaryCodeList?.length) {
        <nimbus-form-row>
          <nimbus-form-control>
            <nimbus-input-autocomplete
              defaultSearch
              [label]="TranslationKeys.GeneralPrimaryCode | icuTranslate: PluralForm.One"
              panelClass="assistant-primary-code"
              [required]="true"
              [options]="task.conversationCodes.primaryCodeList"
              id="primaryCode"
              formControlName="primaryCode"
            >
            </nimbus-input-autocomplete>
          </nimbus-form-control>
        </nimbus-form-row>
      }
      @if (task?.conversationCodes?.secondaryCodeList?.length) {
        <nimbus-form-row>
          <nimbus-form-control>
            <nimbus-input-autocomplete
              [label]="TranslationKeys.GeneralSecondaryCode | icuTranslate: PluralForm.One"
              panelClass="assistant-secondary-code"
              [required]="true"
              [options]="task.conversationCodes.secondaryCodeList"
              id="secondaryCode"
              formControlName="secondaryCode"
            >
            </nimbus-input-autocomplete>
          </nimbus-form-control>
        </nimbus-form-row>
      }
      <nimbus-form-row>
        <nimbus-form-control>
          <nimbus-input-tag-list [label]="TranslationKeys.GeneralTags | translate" formControlName="tags"> </nimbus-input-tag-list>
        </nimbus-form-control>
      </nimbus-form-row>
    </nimbus-form-wrapper>

    @if (isManagedInNimbusOne) {
      <div class="managed-externally">{{ TranslationKeys.GeneralCodesAndTagsManagedInNimbusOne | translate }}</div>
    }
  </div>
}
